<template>
  <v-dialog v-model="dialog" max-width="600">
    <v-card>
      <v-card-text>
        <v-textarea
          v-model="text"
          rows="20"
          outline
          ref="text"
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "com-percent-dialog",
  props: {
    list: {
      type: Array,
      default: () => { return [] }
    }
  },
  data() {
    return {
      text: '',
      dialog: false,
    }
  },
  methods: {
    open() {
      this.dialog = true
      this.getComPercentValueForCurrentList()
    },
    close() {
      this.dialog = false
    },
    getComPercentValueForCurrentList() {
      const grouped = this.list.reduce((acc, item) => {
        const projectName = item.task.project.name;
        const minutes = item.minutes;

        if (!acc[projectName]) {
          acc[projectName] = 0;
        }

        acc[projectName] += minutes;
        return acc;
      }, {});

      const formattedResults = Object.entries(grouped).map(([project, minutes]) => ({
        project,
        totalMinutes: (minutes / 60).toFixed(1).replace(".", ",")
      }));

      this.text = this.generateMarkdownTable(formattedResults)
    },
    generateMarkdownTable(data) {
      return data.map(item => `${item.project} \t ${item.totalMinutes}`).join("\r\n");
    }
  }
}
</script>
